module.exports = "<ng-container *mobxAutorun>\n  \n</ng-container>"